import {Expose} from "class-transformer";
import Model from "./Model";

export default class Conversation extends Model {
    userId1: number;
    userId2: number;
    lastMessageId: number;

    @Expose({name: 'unread_count'})
    unreadCount: number;
}


// WEBPACK FOOTER //
// ./app/client/_data/models/Conversation.ts